import { createContext, useReducer } from "react";
import { reducer, initialGlobalState } from "./reducer";

export const GlobalStateContext = createContext({
    state: initialGlobalState,
    dispatch: () => null
})

export const GlobalStateProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialGlobalState)

    return (
        <GlobalStateContext.Provider value={[state, dispatch]}>
            {children}
        </GlobalStateContext.Provider>
    );
}